export default __webpack_public_path__ + "static/media/camera.785c9a4b.svg";